import { hotelBusinessHomeRoute } from '../../megha/hotel-business-dashboard/hotel-route.util';
import { isHotelStoreType } from './hotel-store-types.util';

export interface HotelStoreLike {
  store_type?: string | null;
  store_code?: string | null;
}

/** First owned hotel / home-stay store (newest first from getUserStores). */
export function findPrimaryHotelStore<T extends HotelStoreLike>(
  stores: T[] | null | undefined
): T | null {
  if (!stores?.length) return null;
  return (
    stores.find((s) => isHotelStoreType(s.store_type) && String(s.store_code || '').trim()) ??
    null
  );
}

export function hotelDashboardCommands(storeCode: string): string[] {
  return hotelBusinessHomeRoute(storeCode);
}
